import { arrayToSimpleObj } from '../utils';

export const monitorSourceOptions = [
  {
    text: 'Customer/User/Audience Reviews',
    value: '1',
  },
  {
    text: 'Critic Reviews',
    value: '2',
  },
];

export const monitorSourceMap = arrayToSimpleObj(monitorSourceOptions);
